$("select.js-currency").on("change", function (e) {
    var that = $(e.currentTarget), href = that.val();
    location.href = href;
})